/* Copyright (c) 2025 Xperi. All Rights Reserved. */

export const ON_SET_GHOST_MODE_RECORDING_ACTIVITY = 'ON_SET_GHOST_MODE_RECORDING_ACTIVITY';
export const ON_SET_RECORDING_ACTIVITY_DATA = 'ON_SET_RECORDING_ACTIVITY_DATA';
export const ON_GO_NEXT_PAGE_RECORDING_ACTIVITY = 'ON_GO_NEXT_PAGE_RECORDING_ACTIVITY';
export const ON_GO_PREVIOUS_PAGE_RECORDING_ACTIVITY = 'ON_GO_PREVIOUS_PAGE_RECORDING_ACTIVITY';
export const ON_SET_VERTICAL_POSITION_RECORDING_ACTIVITY =
    'ON_SET_VERTICAL_POSITION_RECORDING_ACTIVITY';
export const ON_RETRY_FETCH_RECORDING_ACTIVITY_WHEN_ERROR =
    'ON_RETRY_FETCH_RECORDING_ACTIVITY_WHEN_ERROR';
export const ON_SET_RECORDING_ACTIVITY_API_ERROR = ' ON_SET_RECORDING_ACTIVITY_API_ERROR';
export const ON_SET_CURRENT_PAGE_RECORDING_ACTIVITY = 'ON_SET_CURRENT_PAGE_RECORDING_ACTIVITY';
export const ON_SET_TOTAL_COUNT_RECORDING_ACTIVITY = 'ON_SET_TOTAL_COUNT_RECORDING_ACTIVITY';
export const ON_SET_RECORDING_ACTIVITY_SELECTED_ROW_PREVIEW =
    'ON_SET_RECORDING_ACTIVITY_SELECTED_ROW_PREVIEW';
export const ON_SET_CARET_VISIBILITY_RECORDING_ACTIVITY =
    'ON_SET_CARET_VISIBILITY_RECORDING_ACTIVITY';
